import { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setLoading } from "../../../../../redux/Loading/actions";
import { contribuyenteService } from "../../../../../_services/contribuyente.service";
import { inmuebleService } from "../../../../../_services/inmuebles.service";
import { getInmuebles } from "../../../../../redux/Sections/Inmuebles/actions";
import TooltipText from "../../../../../components/TooltipText";
import "./RowData.css";

export const RowData = ({ record }) => {
  const dispatch = useDispatch();
  const [inmuebles, setInmuebles] = useState([]);
  const [loadingRowData, setLoadingRowData] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));
      setLoadingRowData(true);
      try {
        let response = await contribuyenteService.getContribuyente({ recurso: record.RECURSO, imponible: record.IMPONIBLE });

        if (response.contribuyente) {
          let inmuebles = await inmuebleService.getInmuebles({ nombre: response.contribuyente.APYNOM?.trim() });
          setInmuebles(inmuebles);
          dispatch(setLoading(false));
          setLoadingRowData(false);
        }
        else {
          dispatch(setLoading(false));
          setLoadingRowData(false);
        }
      }
      catch (err) {
        dispatch(setLoading(false));
        setLoadingRowData(false);
      }
    };

    getData();
  }, [record]);

  const handleClick = async (imponible, recurso) => {
    try {
      dispatch(setLoading(true));

      dispatch(getInmuebles({ inmueble: imponible, recurso }))
        .then(() => {
          dispatch(setLoading(false));
          return history.push("inmuebles");
        })
        .catch(err => {
          console.log(err);
        });
    }
    catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="rowdata ml-5">
      {!loadingRowData ?
        inmuebles && inmuebles.length ? (
          <Table className="rowdata-subtable" striped bordered hover>
            <thead>
              <tr>
                <th>NRO INMUEBLE</th>
                <th>RECURSO</th>
                <th>LEGAL</th>
              </tr>
            </thead>
            <tbody>
              {inmuebles?.length && inmuebles.map((e, i) => {
                return <Fragment key={e.NRO_INMUEBLE + e.RECURSO + i}>
                  <tr>
                    <td>
                      <div onClick={() => handleClick(e.NRO_INMUEBLE, e.RECURSO)} className="link-custom" >
                        <TooltipText placement="top" text="Buscar deudas del inmueble." >
                          <span>
                            {e.NRO_INMUEBLE}
                          </span>
                        </TooltipText>
                      </div>
                    </td>
                    <td><span>{e.RECURSO}</span></td>
                    <td><span>{e.LEGAL}</span></td>
                  </tr>
                </Fragment>;
              })}
            </tbody>
          </Table>
        ) : <div>
          <span style={{ color: "#a5a5a5" }}>No se encontrarón inmuebles</span>
        </div>
        : "..."}
    </div>
  );
};